export default function MediumRowIcon() {
  return (
    <svg
      width='14'
      height='15'
      viewBox='0 0 14 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='shrink-0 size-3.5'
    >
      <mask
        id='mask0_medium_row'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='14'
        height='15'
      >
        <rect width='14' height='15' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_medium_row)'>
        <path
          d='M1.99811 3.12809C1.99811 2.80309 2.26157 2.53963 2.58657 2.53963H11.4134C11.7384 2.53963 12.0019 2.80309 12.0019 3.12809V4.18202C12.0019 4.50702 11.7384 4.77048 11.4134 4.77048H2.58657C2.26157 4.77048 1.99811 4.50702 1.99811 4.18202V3.12809Z'
          stroke='currentColor'
          strokeWidth='1.17691'
        />
        <path
          d='M12.5903 7.12361C12.5903 6.79862 12.3269 6.53516 12.0019 6.53516H1.99811C1.67311 6.53516 1.40965 6.79862 1.40965 7.12361C1.40965 7.44861 1.67311 7.71207 1.99811 7.71207H12.0019C12.3269 7.71207 12.5903 7.44861 12.5903 7.12361Z'
          fill='currentColor'
        />
        <path
          d='M12.5903 9.47713C12.5903 9.15213 12.3269 8.88867 12.0019 8.88867H1.99811C1.67311 8.88867 1.40965 9.15213 1.40965 9.47713C1.40965 9.80213 1.67311 10.0656 1.99811 10.0656H12.0019C12.3269 10.0656 12.5903 9.80213 12.5903 9.47713Z'
          fill='currentColor'
        />
        <path
          d='M12.5903 11.8326C12.5903 11.5076 12.3269 11.2441 12.0019 11.2441H1.99811C1.67311 11.2441 1.40965 11.5076 1.40965 11.8326C1.40965 12.1576 1.67311 12.4211 1.99811 12.4211H12.0019C12.3269 12.4211 12.5903 12.1576 12.5903 11.8326Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
